/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from "@mui/material";
import React from "react";

import YesNoAction from "../../components/YesNoAction";
import { TestIds } from "../../testIds";
import { URLS } from "../../util/consts";

import OrderCard from "./components/OrderCard";
import { SalesOrder } from "./storage/types";

export const OrderListContainer = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  [theme.breakpoints.down("sm")]: {
    gap: "8px",
  },
}));

interface OrderListProps {
  data: SalesOrder[] | null;
}

const OrderList = ({ data }: OrderListProps) => {
  function onClickFindStore() {
    window.open(URLS.findStore, "_blank");
  }

  if (!data) {
    return (
      <div data-testid={TestIds.feat.orders.list.noOrders}>
        <YesNoAction
          body="You do not currently have any orders to display. Your order will be displayed here once you place an order with Farmlands."
          optionA={{
            label: "Find a store",
            onClick: onClickFindStore,
          }}
        />
      </div>
    );
  }
  return (
    <OrderListContainer>
      {data.map((x) => (
        <OrderCard data={x} key={x.salesId} />
      ))}
    </OrderListContainer>
  );
};

export default OrderList;
